import z from 'zod';

const geogebraEntrySchema = z.object({
  base64: z.string().optional()
});

export { geogebraEntrySchema };
//# sourceMappingURL=geogebra.entry-data.js.map
